




















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({name: 'HeaderImg'})
export default class HeaderImg extends Vue {
  @Prop()
  public readonly src!: string;
  @Prop()
  public readonly isMini!: boolean;
  @Prop()
  public readonly dark!: boolean;
}
